import printPDF from "./print";

const makePDF = (dailyReport, ReportType = "dailyReport") => {
  printPDF(dailyReport, ReportType);
};
export default makePDF;
